import { CaretDownFilled, CaretUpOutlined } from "@ant-design/icons";
import MerchantSelect from "../select/merchant";
import { useAdmin } from "../../context/adminContext";

const SearchAdminByMerchant = ({
  title,
  fieldName,
  width = 200,
  sort = true,
}) => {
  const { searchFields, setSearchFields, showFilter } = useAdmin();
  const selectChange = (value) => {
    setSearchFields((e) => {
      return { ...e, [fieldName]: value || null };
    });
  };
  const sortChange = (sort) => {
    setSearchFields({ ...searchFields, sort: sort, sortField: fieldName });
  };
  return (
    <div key={fieldName}>
      <div className="titleWithSort">
        <span style={{ fontSize: 12 }}>{title}</span>
        {sort && (
          <div className="sortIcons">
            <CaretUpOutlined
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("asc")}
            />
            <CaretDownFilled
              className="sortIcon"
              style={{ color: "#45a898" }}
              onClick={() => sortChange("desc")}
            />
          </div>
        )}
      </div>
      {showFilter && (
        <>
          <div className="line" />
          <MerchantSelect
            size={"small"}
            width={width}
            onChange={selectChange}
            value={(searchFields && searchFields[fieldName]) || null}
          />
        </>
      )}
    </div>
  );
};
export default SearchAdminByMerchant;
